export default "__VITE_ASSET__z_yy9w_3__"